import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { setFlow } from '../../store/flow/action-creators';
import { Step } from '../../views/Step';
import { getIsMobile } from '../../utils/deviceUtils';
import { isPreVerification } from '../../flow-settings/settingsSelectors';
import { getGSWHVariantAPostVerificationSteps, preFillHubInterestGSWH } from '../../experiments/gswhV1/gswhUtils';
import { Flow } from 'signup-constants/Flow';
import { isFlow } from '../../utils/isFlow';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
export const BranchACQ140VariantA = {
  name: 'BranchACQ140VariantA',
  stateCheck: state => {
    return getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0140, [ExperimentParameterGroup.Variant_A]);
  },
  rebuildFlow: (flow, state, dispatch) => {
    const {
      preVerification,
      postExistingAccountSelection
    } = getFlowSteps();
    const postVerificationSteps = getGSWHVariantAPostVerificationSteps();
    const postAccountCreationSteps = getIsMobile() ? [Step.MobileAppPrompt] : [];

    if (!isFlow(Flow.Crm)) {
      preFillHubInterestGSWH(dispatch);
    }

    const nextSteps = [...(isPreVerification() ? preVerification : []), ...postVerificationSteps, ...postAccountCreationSteps];
    dispatch(setFlow(nextSteps, preVerification, postVerificationSteps, postAccountCreationSteps, postExistingAccountSelection));
    return nextSteps;
  },
  processed: false,
  processedOnStep: Step.LandingPage,
  afterData: null,
  afterStep: null
};